import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchPosts } from "../lib/api";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { fetchPosts({ limit: 50 }).then(setPosts).catch(() => {}); }, []);
  return (
    <>
      <Seo title="Blog — Lime Driving School Southampton" description="Tips, advice and news from Lime Driving School in Southampton." />
      <PageHero
        eyebrow="Blog"
        title="Driving tips & news"
        subtitle="Practical advice, test-day tips and updates from your Southampton driving school."
      />
      <section className="py-16 md:py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="blog-page">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map(p => (
            <Link key={p.post_id} to={`/blog/${p.slug}`} className="group bg-white border border-black/5 rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform" data-testid={`blog-card-${p.slug}`}>
              {p.featured_image && (
                <div className="aspect-[16/10] overflow-hidden bg-[#F3F4F6]">
                  <img src={p.featured_image} alt={p.title} className="w-full h-full object-cover" />
                </div>
              )}
              <div className="p-6">
                <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#37B160]">{p.category}</div>
                <h2 className="mt-3 text-lg font-medium group-hover:text-white" style={{fontFamily:"Outfit, sans-serif"}}>{p.title}</h2>
                <p className="mt-2 text-sm text-[#4B5563] leading-relaxed">{p.excerpt}</p>
                <div className="mt-4 text-sm text-white inline-flex items-center gap-1">Read more <ArrowRight className="h-3.5 w-3.5" /></div>
              </div>
            </Link>
          ))}
          {posts.length === 0 && <div className="text-[#9CA3AF]">No posts yet.</div>}
        </div>
      </section>
    </>
  );
}
